<template>
  <div
    class="placements-hint-wrapper"
  >
    <div>{{ _getTr("this_placement_is_already_linked_to_orders") }}</div>
    <div
      v-for="order in data"
      :key="`placement-hint-${order.order_id}`"
      class="placement-hint-info"
    >
      <div>
        <span class="placement-hint-order-value">{{ order.order_id }}</span> на
        <span class="placement-hint-order-dates">
          {{ getFormattedStartDate(order.start_date) }} — {{ getFormattedStartDate(order.end_date) }}
        </span>
      </div>
    </div>
    <div v-if="isIntersectionDates">
      {{ _getTr("you_can_use_it_on_other_dates") }}
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'PlacementHint',
    props: {
      data: {
        type: Array,
        default: null
      },
      isIntersectionDates: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      getFormattedStartDate (date) {
        return moment(date).format('DD.MM.YYYY');
      }
    }
  };
</script>

<style>
  .placement-hint-order-value,
  .placement-hint-order-dates {
    color: var(--action-color);
  }
</style>
